var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.8125C8.27557 2.8125 7.55122 2.89576 6.84128 3.06229C4.96621 3.50212 3.50212 4.9662 3.06229 6.84128C2.72923 8.26117 2.72923 9.73882 3.06229 11.1587C3.50212 13.0338 4.96621 14.4979 6.84128 14.9377C8.26117 15.2708 9.73882 15.2708 11.1587 14.9377C13.0338 14.4979 14.4979 13.0338 14.9377 11.1587C15.1042 10.4488 15.1875 9.72435 15.1875 9C15.1875 8.68935 15.4393 8.4375 15.75 8.4375C16.0606 8.4375 16.3125 8.68935 16.3125 9C16.3125 9.8106 16.2193 10.6212 16.033 11.4156C15.4956 13.7067 13.7067 15.4956 11.4156 16.033C9.8268 16.4057 8.1732 16.4057 6.58437 16.033C4.29331 15.4956 2.50443 13.7067 1.96702 11.4157C1.59433 9.8268 1.59433 8.1732 1.96702 6.58436C2.50443 4.29331 4.29331 2.50443 6.58437 1.96702C7.37879 1.78067 8.1894 1.6875 9 1.6875C9.31065 1.6875 9.5625 1.93934 9.5625 2.25C9.5625 2.56066 9.31065 2.8125 9 2.8125Z",
    fill: "#14489F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1875 2.25C12.1875 1.93934 12.4394 1.6875 12.75 1.6875H15.75C16.0607 1.6875 16.3125 1.93934 16.3125 2.25V5.75C16.3125 6.06066 16.0607 6.3125 15.75 6.3125C15.4394 6.3125 15.1875 6.06066 15.1875 5.75V3.77058L11.6771 7.86608C11.4749 8.10195 11.1198 8.12925 10.8839 7.92705C10.6481 7.72493 10.6208 7.3698 10.823 7.13393L14.527 2.8125H12.75C12.4394 2.8125 12.1875 2.56066 12.1875 2.25Z",
    fill: "#14489F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogout);
export default __webpack_public_path__ + "static/media/profile_logout.12f96a374e0745aac90a5238c4d0cf9b.svg";
export { ForwardRef as ReactComponent };